import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  deleteSinglePendingArtisanProductSuccessAction,
  getPendingArtisanProductsSuccessAction,
  getSinglePendingArtisanProductSuccessAction,
  moderateCreateSinglePendingArtisanProductSuccessAction,
  setPendingArtisanProductsCountAction,
  setPendingArtisanProductsIsLoadingAction,
  updatePendingArtisanProductSuccessAction,
} from './Actions';
import { push } from 'react-router-redux';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../notifications/Actions';

import { authUserIdSelector } from '../../auth/Selectors';

import { actions } from './Reducer';
import * as api from './Api';

function* getPendingArtisanProducts({ payload }) {
  const defData = {
    // offset: 0,
    // size: 10,
    // sort: "createdAt",
    // dir: "asc",
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [],
    filterCountry: '',
    sort: 'createdAt',
    dir: 'asc',
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingArtisanProductsIsLoadingAction(true));
    const response = yield call(api.getPendingArtisanProducts, body);
    const { data } = response;
    const { content, count } = data;

    yield put(getPendingArtisanProductsSuccessAction(content));
    yield put(setPendingArtisanProductsCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisanProductsIsLoadingAction(false));
  }
}

function* updatePendingArtisanProduct({ payload }) {
  const moderatorID = yield select(authUserIdSelector);
  const defData = {
    moderatorID,
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingArtisanProductsIsLoadingAction(true));
    yield call(api.updatePendingArtisanProduct, body);
    yield put(newSuccessNotificationAction('Product Moderated'));

    yield put(
      updatePendingArtisanProductSuccessAction(body.moderationRecordID)
    );
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisanProductsIsLoadingAction(false));
  }
}


function* getSinglePendingArtisanProduct({payload}) {
  const id = payload
  try {
    yield put(setPendingArtisanProductsIsLoadingAction(true))
    const response = yield call(api.getSinglePendingArtisanProdcut, id)
    const { data} = response
    yield put(getSinglePendingArtisanProductSuccessAction(data))
  } catch(error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisanProductsIsLoadingAction(false))
  }
}

function* deleteSinglePendingArtisanProduct({payload}) {
  const id = payload;
  try {
    yield put(setPendingArtisanProductsIsLoadingAction(true))
    yield call(api.deleteSinglePendingArtisanProdcut, id)
    yield put(deleteSinglePendingArtisanProductSuccessAction(id))
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisanProductsIsLoadingAction(false))
  }
}


function* moderateCreateSinglePendingArtisanProduct({ payload , mode}) {
  const id = payload;
  try {
    yield put(setPendingArtisanProductsIsLoadingAction(true));
    if (mode === 'update')  {
     const response = yield call(api.moderateUpdateSinglePendingArtisanProduct, id)
      const {data} = response
      yield put(moderateCreateSinglePendingArtisanProductSuccessAction(id))
      yield put(push('/artisans-moderation/products'))
      yield put(newSuccessNotificationAction('Artisan Update Product Moderated'));
    } else {

      const response = yield call(api.moderateCreateSinglePendingArtisanProduct, id)
      const {data} = response
      yield put(moderateCreateSinglePendingArtisanProductSuccessAction(id))
      yield put(push('/artisans-moderation/products'))
      yield put(newSuccessNotificationAction('Artisan Product Moderated'));

    }
    
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingArtisanProductsIsLoadingAction(false))
  }
}


export default function*() {
  yield takeLatest(
    actions.GET_PENDING_ARTISAN_PRODUCTS,
    getPendingArtisanProducts
  );

  yield takeLatest(
    actions.UPDATE_PENDING_ARTISAN_PRODUCT,
    updatePendingArtisanProduct
  );
  yield takeLatest(actions.GET_SINGLE_PENDING_ARTISAN_PRODUCT,getSinglePendingArtisanProduct )
  yield takeLatest(actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT,moderateCreateSinglePendingArtisanProduct)
  yield takeLatest(actions.DELETE_SINGLE_PENDING_ARTISAN_PRODUCT, deleteSinglePendingArtisanProduct)
}
